import { useEffect, useState } from "react";
import api from "../lib/api";
import { useLang } from "./LanguageContext";

const cache = {};

// Full-depth translated pillar bodies (AI-translated, admin-editable).
export function useTranslatedPillar(slug) {
  const { lang } = useLang();
  const [content, setContent] = useState(() => cache[lang]?.[slug] || null);

  useEffect(() => {
    if (lang === "en") {
      setContent(null);
      return;
    }
    if (cache[lang]) {
      setContent(cache[lang][slug] || null);
      return;
    }
    let alive = true;
    api
      .get(`/content/pillars/${lang}`)
      .then((r) => {
        cache[lang] = r.data || {};
        if (alive) setContent(cache[lang][slug] || null);
      })
      .catch(() => {
        cache[lang] = {};
        if (alive) setContent(null);
      });
    return () => {
      alive = false;
    };
  }, [lang, slug]);

  return content;
}
